import React, { ReactNode } from 'react'

import type { ListElementType as ListElementTypeEnum } from '@mieterengel/database-types/types/enums'
import { Editor, Element as SlateElement, Transforms } from 'slate'
import { useSlate } from 'slate-react'

import { Toolbar } from '@app/lib/inputs/RichEditor/editor/Toolbar'
import {
  StructuredTextElement,
  ListElementType,
  ListItemElementType,
  TextElementType
} from '@app/lib/inputs/RichEditor/types'

export type BlockButtonProps = {
  format: StructuredTextElement['type']
  icon: ReactNode
  'aria-label': string
}

export const BlockButton = ({ format, icon, 'aria-label': ariaLabel }: BlockButtonProps) => {
  const editor = useSlate()
  return (
    <Toolbar.Button
      aria-label={ariaLabel}
      active={isBlockActive(editor, format)}
      onMouseDown={(event) => {
        event.preventDefault()
        toggleBlock(editor, format)
      }}
      icon={icon}
    />
  )
}

const LIST_TYPES = [ListElementType.NumberedList, ListElementType.BulletedList]

const toggleBlock = (editor: Editor, format: StructuredTextElement['type']) => {
  const isActive = isBlockActive(editor, format)
  const isList = LIST_TYPES.includes(format as ListElementTypeEnum)

  Transforms.unwrapNodes(editor, {
    match: (n) =>
      !Editor.isEditor(n) &&
      SlateElement.isElement(n) &&
      LIST_TYPES.includes(n.type as ListElementTypeEnum),
    split: true
  })

  if (isActive) {
    Transforms.setNodes<SlateElement>(editor, {
      type: TextElementType.Paragraph
    })
  } else {
    if (isList) {
      Transforms.setNodes<SlateElement>(editor, {
        type: ListItemElementType.ListItem
      })
      const block = { type: format, children: [] }
      Transforms.wrapNodes(editor, block as StructuredTextElement)
    } else {
      Transforms.setNodes<SlateElement>(editor, {
        type: format
      })
    }
  }

  if (!isActive && isList) {
  }
}

const isBlockActive = (editor: Editor, format: string) => {
  const { selection } = editor
  if (!selection) return false

  const [match] = Array.from(
    Editor.nodes(editor, {
      at: Editor.unhangRange(editor, selection),
      match: (n) => !Editor.isEditor(n) && SlateElement.isElement(n) && n.type === format
    })
  )

  return !!match
}
